export const VALIDATION_RULES = {
    email: {
        maxCharacters: 70,
    },
    dateOfBirth: {
        maxAge: 120,
    },
};
